import { render, staticRenderFns } from "./PanelEstadisticas.vue?vue&type=template&id=28fe9d6a&scoped=true&"
import script from "./PanelEstadisticas.vue?vue&type=script&lang=js&"
export * from "./PanelEstadisticas.vue?vue&type=script&lang=js&"
import style0 from "./PanelEstadisticas.vue?vue&type=style&index=0&id=28fe9d6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fe9d6a",
  null
  
)

export default component.exports